if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();



      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    connectedCallback() {
      this.bbQuantityChanged = () => this.updatePickupQuantity();
      this.bbScope = this.closest('product-info') || this.closest('.shopify-section') || this.parentElement;
      this.bbScope.addEventListener('input', this.bbQuantityChanged);
      this.bbScope.addEventListener('change', this.bbQuantityChanged);
    }

    disconnectedCallback() {
      this.bbScope?.removeEventListener('input', this.bbQuantityChanged);
      this.bbScope?.removeEventListener('change', this.bbQuantityChanged);
    }

    updatePickupQuantity() {
      const preview = this.querySelector('[data-bb-stock]');
      if (!preview) return;
      const input = this.bbScope?.querySelector('input[name="quantity"]');
      const quantity = Math.max(Number(input?.value) || Number(preview.dataset.bbMin) || 1, 1);
      const text = Number(preview.dataset.bbStock) >= quantity ? 'Sofort abholbereit' : preview.dataset.bbWait;
      this.querySelectorAll('[data-bb-pickup-status]').forEach(el => el.textContent = text);
      document.querySelectorAll('pickup-availability-drawer [data-bb-pickup-status]').forEach(el => el.textContent = text);
    }

    fetchAvailability(variantId) {
      this.dataset.variantId = String(variantId);
      const request = this.bbRequest = (this.bbRequest || 0) + 1;
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          if (request !== this.bbRequest) return;
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          if (request !== this.bbRequest) return;
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = '';
      }
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('pickup-availability-drawer');
      if (drawer) drawer.remove();
      const overlay = document.querySelector('.pickup-overlay');
      if (overlay) overlay.remove();
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
      document.body.appendChild(sectionInnerHTML.querySelector('.pickup-overlay'));
      this.updatePickupQuantity();

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.currentTarget);
      });
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);

      this.querySelector('button').addEventListener('click', () => {
        this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && !target.closest('#ShowPickupAvailabilityDrawer')) {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.body.classList.remove('overflow-hidden');
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      document.body.classList.add('overflow-hidden');
      trapFocus(this);
    }
  });
}
